'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = BibleReferences;

var _bibleBookNames = require('./bible-book-names');

function BibleReferences() {
  var bookNames = _bibleBookNames.getLanguages.apply(undefined, arguments);
  var normaliseBookName = (0, _bibleBookNames.getNormaliseBookName)(bookNames);
  var normaliseBookNameShort = (0, _bibleBookNames.getNormaliseBookNameShort)(bookNames);
  var anyBookInAnyForm = bookNames.map(function (names) {
    return names.join('|');
  }).join('|');
  var chapter = '\\d{1,3}';
  var verse = '\\d{1,3}';

  var bookChapterVerse = new RegExp('^(' + anyBookInAnyForm + ')\\s*(' + chapter + ')[ ]*:[ ]*(' + verse + ')\\b');
  var bookChapter = new RegExp('^(' + anyBookInAnyForm + ')[ ]*(' + chapter + ')\\b');
  var bookRegex = new RegExp('^(?:' + anyBookInAnyForm + ')$');
  var chapterVerse = new RegExp('^(' + chapter + ')[ ]*:[ ]*(' + verse + ')\\b');
  var bookFf = new RegExp('^(?:' + anyBookInAnyForm + ')[ ]*ff');

  /* eslint-disable no-cond-assign */
  function rightToRangeEnd(right, isFf, ctx) {
    var match = void 0;
    var out = {};
    // unterminated range
    if (right === '') return {};
    if (isFf) {
      if (ctx.book && ctx.chapter && ctx.verse) {
        out = {
          book: ctx.book,
          chapter: ctx.chapter
        };
      } else if (ctx.book && ctx.chapter) {
        out = {
          book: ctx.book
        };
      }
      return out;
    }

    if (right === undefined) return _extends({}, ctx);

    if (match = right.match(bookChapterVerse)) {
      out = {
        book: normaliseBookName(match[1]),
        chapter: match[2],
        verse: match[3]
      };
    } else if (match = right.match(bookChapter)) {
      out = {
        book: normaliseBookName(match[1]),
        chapter: match[2]
      };
    } else if (match = right.match(bookRegex)) {
      out = {
        book: normaliseBookName(match[0])
      };
    } else if (match = right.match(chapterVerse)) {
      out = {
        book: ctx.book,
        chapter: match[1],
        verse: match[2]
      };
    } else if (match = right.match(/(\d{1,3}\b)/)) {
      if (ctx.verse) {
        out = {
          book: ctx.book,
          chapter: ctx.chapter,
          verse: match[1]
        };
      } else {
        out = {
          book: ctx.book,
          chapter: match[1]
        };
      }
    } else {
      out = _extends({}, ctx);
    }
    return out;
  }

  function partToRange(part, ctx) {
    var match = void 0;
    var start = void 0;
    var isFf = false;

    var _part$split$map = part.split('-').map(function (s) {
      return s.trim().toLowerCase();
    });

    var _part$split$map2 = _slicedToArray(_part$split$map, 2);

    var left = _part$split$map2[0];
    var right = _part$split$map2[1];

    if (/\d{1,3}[ ]*ff$/i.test(left) || bookFf.test(left)) {
      left = left.replace(/[ ]*ff$/, '');
      isFf = true;
    }

    if (match = left.match(bookChapterVerse)) {
      start = {
        book: normaliseBookName(match[1]),
        chapter: match[2],
        verse: match[3]
      };
      ctx = _extends({}, start);
    } else if (match = left.match(bookChapter)) {
      start = {
        book: normaliseBookName(match[1]),
        chapter: match[2],
        verse: '1'
      };
      ctx = {
        book: start.book,
        chapter: start.chapter
      };
    } else if (match = left.match(bookRegex)) {
      start = {
        book: normaliseBookName(match[0]),
        chapter: '1',
        verse: '1'
      };
      ctx = { book: start.book };
    } else if (match = left.match(chapterVerse)) {
      start = {
        book: ctx.book,
        chapter: match[1],
        verse: match[2]
      };
      ctx = _extends({}, start);
    } else if (match = left.match(/(\d{1,3}\b)/)) {
      if (ctx.verse) {
        start = {
          book: ctx.book,
          chapter: ctx.chapter,
          verse: match[1]
        };
        ctx = _extends({}, start);
      } else {
        start = {
          book: ctx.book,
          chapter: match[1],
          verse: '1'
        };
        ctx = {
          book: start.book,
          chapter: start.chapter
        };
      }
    }

    return {
      start: start,
      end: rightToRangeEnd(right, isFf, ctx),
      ctx: ctx
    };
  }

  /* eslint-enable no-cond-assign */

  var getVerseRanges = function getVerseRanges(refs) {
    var _refs$split$reduce = refs.split(/[,\n;]+/g).reduce(function (acc, ref) {
      var range = partToRange(ref, acc.ctx);
      acc.ctx = range.ctx;
      if (range.start) {
        acc.ranges.push({
          start: range.start,
          end: range.end
        });
      }
      return acc;
    }, {
      ctx: { book: 'genesis' },
      ranges: []
    });

    var ranges = _refs$split$reduce.ranges;

    return ranges;
  };

  this.getVerseRanges = getVerseRanges;
  this.bookNames = bookNames;
  this.normaliseBookName = normaliseBookName;
  this.normaliseBookNameShort = normaliseBookNameShort;
  this.partToRange = partToRange;
}


//////////////////
// WEBPACK FOOTER
// ../~/bible-references/lib/bible-book-regex.js
// module id = 117
// module chunks = 0 1